const html = require("./html/serviceView.html");
import {setElementsFromScope, insertValAndManageFocus, show, hide, enableInput, disableInput, handleDisplayFor} from "../../../utilities/selectorHelpers";
import _ from "underscore";
import $ from "jquery";
import AsnDetailStore from "../../../stores/AsnDetailStore";
import ProductItemStore from "../../../stores/ProductItemStore";
import ServiceStore from "../../../stores/CmrServiceStore";
import DomainStore from "../../../stores/CmrDomainStore";
import {toCurrency} from "../../../utilities/currency";

const noop = ()=>{};

const elementsMap = {
  serviceName: ".service-name",
  serviceCurrencyPerUnit: ".service-currency-per-unit",
  serviceCurrentTotal: ".service-currency-total",
  closeBtn: ".service-remove-btn"
};

export default function ServiceView(service,
  {
    onRemoveServiceRow,
    getAggregateCurrencyTotalViaCurrencyPerUnits,
    shouldShowServiceCloseBtn,
    shouldShowCurrencyPerUnits,
    readOnly
  }={}
  ){
  const serviceId = service.id;
  const self = this;
  self._element = $();
  const els = {};

  shouldShowServiceCloseBtn = shouldShowServiceCloseBtn || defaultShouldShowCloseBtn;
  shouldShowCurrencyPerUnits = shouldShowCurrencyPerUnits || defaultShouldShowCurrencyPerUnits;
  getAggregateCurrencyTotalViaCurrencyPerUnits = getAggregateCurrencyTotalViaCurrencyPerUnits || noop;

  self.init = function(){
    render();
  };

  function bindElements(){
    els.closeBtn.on("click", handleRemoveRowClick);
  }

  function handleRemoveRowClick(e){
    e.preventDefault();
    onRemoveServiceRow(serviceId);
  }

  function bindStores(){
    // AsnDetailStore.bindListener(`asn_details:change:${productId}`, update);
  }

  self.unbindListeners = function(){
    // AsnDetailStore.bindListener(`asn_details:change:${productId}`, update);
  };

  function setWidgets(){

  }

  function setElements(){
    setElementsFromScope(els, elementsMap, self._element);
  }

  self.getElement = function(){
    return self._element;
  }

  function update(){
    updateGlobalText();
    updateGlobalValues();
  }

  function updateGlobalText(){
    const domain = getDomain();
    els.serviceName.text(DomainStore.getTitle(domain));
    els.serviceCurrencyPerUnit.text(`${DomainStore.currencyToHtml(domain)}/unit`);
    handleDisplayFor(els.serviceCurrencyPerUnit, shouldShowCurrencyPerUnits());
    if(DomainStore.currencyToHtml(domain) == 'FREE'){
      els.serviceCurrentTotal.text('FREE');
    }else{
      els.serviceCurrentTotal.text(
        toCurrency(getAggregateCurrencyTotalViaCurrencyPerUnits(DomainStore.getValue(domain)))
      );
    }
    handleDisplayFor(els.closeBtn, (!readOnly && shouldShowServiceCloseBtn({service: getService(), domain: getDomain()})));
  }

  function defaultShouldShowCurrencyPerUnits(){
    return true;
  }

  function defaultShouldShowCloseBtn(){
    return true;
  }

  function updateGlobalValues(){

  }

  function render(){
    self._element = $(html);
    setElements();
    setWidgets();
    bindElements();
    bindStores();
    update();
  }

  function getAsnDetail(){
    return AsnDetailStore.getAsnDetail(productId);
  }

  function getService(){
    return ServiceStore.getData()[serviceId];
  }

  function getDomain(){
    return DomainStore.getData()[getService().cdm_id];
  }
}



// WEBPACK FOOTER //
// ./src/pages/asns/ServicesTab/ServiceView.js